// src/redirects.js

const redirects = {
  "/index2.html": "/",
  "/discovering-the-smart-quotient-in-indias-smart-cities":
    "/latest-updates/discovering-the-smart-quotient-in-indias-smart-cities",
  "/embracing-ict-to-fortify-the-banking-sector":
    "/latest-updates/embracing-ict-to-fortify-the-banking-sector",
  "/smarter-cyberattacks-push-india-to-ramp-up-security-investments":
    "/latest-updates/smarter-cyberattacks-push-india-to-ramp-up-security-investments",
  "/indias-phenomenal-rise-as-a-global-hub-for-data-embassies":
    "/latest-updates/indias-phenomenal-rise-as-a-global-hub-for-data-embassies",
  "/index.html": "/",
  "/ishan-technologies-expands-its-footprint-with-launch-of-data-centre-in-mumbai":
    "/latest-updates/ishan-technologies-expands-its-footprint-with-launch-of-data-centre-in-mumbai",
  "/ishan-technologies-certified-as-a-great-place-to-work":
    "/latest-updates/ishan-technologies-certified-as-a-great-place-to-work",
  "/tier-1-to-tier-4-finding-the-perfect-data-center-fit-for-your-business":
    "/latest-updates/tier-1-to-tier-4-finding-the-perfect-data-center-fit-for-your-business",
  "/latest-updates/5-types-of-workloads-best-suited-for-a-colocation-data-center":
    "/latest-updates/5-types-of-workloads-best-suited-for-a-colocation",
  "/internet-": "/",
  "/cloud-interconnect-what-do-you-need-to-know":
    "/latest-updates/cloud-interconnect-what-do-you-need-to-know",
  "/future-proofing-the-indian-banking-sector-with-advanced-it-solutions":
    "/latest-updates/future-proofing-the-indian-banking-sector-with-advanced-it-solutions",
  "/enhancing-network-security-and-performance-with-sase":
    "/latest-updates/enhancing-network-security-and-performance-with-sase",
  "/latest-updates/this-is-test": "/", // This one to block or redirect to home
  "/data-center-as-a-service-dcaas-for-business":
    "/latest-updates/data-center-as-a-service-dcaas-for-business",
  "/maximizing-efficiency-the-power-of-sdwan-and-sase-integration":
    "/latest-updates/maximizing-efficiency-the-power-of-sdwan-and-sase-integration",
  "/latest-updates/blog:-sd-wan": "/latest-updates/key-benefits-sd-wan",
  "/indias-cloud-rush-balancing-growth-with-green-commitments":
    "/latest-updates/indias-cloud-rush-balancing-growth-with-green-commitments",
  "/reimagining-the-contact-center-in-the-digital-first-era":
    "/latest-updates/reimagining-the-contact-center-in-the-digital-first-era",
  "/ishan-selects-amd-to-power-sovereign-cloud-infrastructure":
    "/latest-updates/ishan-selects-amd-to-power-sovereign-cloud-infrastructure",
  "/power-of-sase-transforming-cybersecurity-for-the-digital-era":
    "/latest-updates/power-of-sase-transforming-cybersecurity-for-the-digital-era",
  "/network-services/high-speed-broadband/plans":
    "https://www.merabroadband.com/home",
  "/network-services/high-speed-broadband":
    "https://www.merabroadband.com/",

  // --- Added parameterized homepage URLs (redirect to canonical homepage) ---
  "/?trk=public_post_main-feed-card-text": "/",
  "/?trk=public_post_comment-text": "/",
  "/?ref=palisade.email": "/",
  "/?trk=public_post_reshare-text": "/",
  "/?trk=public_post_main-feed-card_reshare-text": "/",
  "/?pos=Business Development Manager": "/",
  "/?cmd=getReciptHtml&invoice_no": "/",
};

export default redirects;
